module.exports = __webpack_public_path__ + "c595e645e3034106713109cb3c66d1f4.svg";